import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ClientsLexiClient, PartenaireDoublonDto, ProfilPartenaireDto, ProfilPartenairesLexiClient } from '@lexi-clients/lexi';
import { DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { PartenaireCategorieEnum, partenaireCategories, partenaireCategoriesLibellesMap } from 'lexi-angular/src/app/models/enums/partenaireCategorie';
import { NotificationType } from 'lexi-angular/src/app/modules/shared/references/references';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-partenaire-doublons-details',
    templateUrl: './partenaire-doublons-details.component.html',
    styleUrls: ['./partenaire-doublons-details.component.scss'],
    standalone: false
})
export class PartenaireDoublonsDetailsComponent implements OnInit {

  @Input() dataSource: PartenaireDoublonDto[];
  @Output() setDataSourceSignal = new EventEmitter<boolean>();
  @ViewChild('gridContainerDetails', { static: false }) dataGridDetails: DxDataGridComponent;
  initialized = false;
  partenaireCategorie = PartenaireCategorieEnum.clients;
  partenaireCategories = partenaireCategories;
  isPartenaireCategorieFige: boolean = true;
  recuperationTemplateEncours = false;
  profilPartenaireDataSource: ProfilPartenaireDto[] = [];
  grilleStorageKey = "grilles_doublons_partenaire_list";
  selectedRowsData : PartenaireDoublonDto[];
  cellsDiff : any[] = [];
  isMerging : boolean = false;

  constructor(
    private readonly clientsLexiClient: ClientsLexiClient,
    private readonly profilPartenairesLexiClient: ProfilPartenairesLexiClient,

  ) { }

  async ngOnInit() {
    this.profilPartenaireDataSource = await lastValueFrom(this.profilPartenairesLexiClient.getAll())
  }

  get hasValidSelection(): boolean {
    return this.selectedRowsData?.length > 1 &&
           this.selectedRowsData.some(row => row.isReference) && !this.isMerging;
  }
  get partenaireCategorieIntitule(): string {
      return partenaireCategoriesLibellesMap.get(this.partenaireCategorie);
  }
  onSelectedRowsChanged(e : {selectedRowsData: PartenaireDoublonDto[], component : any, currentDeselectedRowKeys: PartenaireDoublonDto[]}) {

    const wasEmpty = !this.selectedRowsData?.length;
    const allRowsSelected = e.selectedRowsData.length === this.dataSource.length;

    if (wasEmpty && allRowsSelected) {
        e.selectedRowsData[0].isReference = true;
    }
    // Si on désélectionne un élément alors on s'assure que son isReference est à false
    if(e.currentDeselectedRowKeys.length > 0){
      for(const item of e.currentDeselectedRowKeys) {
        item.isReference = false;
      }
      this.cellsDiff = [];
    }

    // Si on désélectionne tout alors on ramène les références à false et on retire les styles
    if(e.selectedRowsData.length == 0 && this.selectedRowsData.length > 0){
      for(const item of this.selectedRowsData) {
        item.isReference = false;
      }
      this.cellsDiff = [];
    }

    this.selectedRowsData = e.selectedRowsData;

    // Si une seule ligne est sélectionnée, on la met en référence par défaut
    if(this.selectedRowsData.length == 1){
      this.selectedRowsData[0].isReference = true;
    }
    this.dataGridDetails.instance.refresh();
    this.setDifferences();
  }

  setSelectedPartenaireReferenceId = (newData, value, currentRowData) =>{
    for(const item of this.selectedRowsData) {
      if(item.id === currentRowData.id) {
        item.isReference = value
      }else{
        item.isReference = false;
      }
    }
    currentRowData.isReference = value;
    this.cellsDiff = [];
    this.setDifferences();
  }

  isRowSelected(rowData: PartenaireDoublonDto): boolean {
    return this.selectedRowsData?.some(row => row.id === rowData.id);
  }

  setDifferences = () =>{
    const referenceRow : PartenaireDoublonDto = this.selectedRowsData.find(row => row.isReference);
    if(referenceRow != null){
      let nonReferenceRows : PartenaireDoublonDto[] = this.selectedRowsData.filter(row => row.id !== referenceRow.id);
      for (const item of nonReferenceRows) {
        // Récupérer tous les champs de l'objet sauf certains à exclure
        const propertiesToCompare = Object.keys(referenceRow).filter(key =>
          key !== 'id' &&
          key !== 'isReference' &&
          typeof referenceRow[key] !== 'function'
        );

        // Comparer chaque propriété
        for (const property of propertiesToCompare) {
          const referenceValue = referenceRow[property];
          const currentValue = item[property];
          if(referenceValue !== currentValue) {
            // Logique de changement de couleur pour cellule avec cette propriété sur "item"
            const cellElement = this.dataGridDetails.instance.getCellElement(0, property);
            if(cellElement != null){
              this.cellsDiff.push({rowId : item.id, fieldName : property, cellElement : cellElement});
            }
          }
        }
      }
    }
  }

  // Utiliser onCellPrepared pour changer la couleur de la cellule
  onCellPrepared = (e) =>{
    if (e.rowType === 'data') {
      const isDifferent = this.cellsDiff.some(diff => diff.rowId === e.data.id && diff.fieldName === e.column.dataField);

      if (isDifferent) {
        e.cellElement.style.backgroundColor = 'orange';
      }else{
        e.cellElement.style.removeProperty('background-color');
      }
    }
  }

  fusionnerSelection = async () =>{
    if(this.selectedRowsData.length > 1 && this.selectedRowsData.some(row => row.isReference)){
      this.isMerging = true;
      try {
      await lastValueFrom(this.clientsLexiClient.dedoublonner(this.selectedRowsData));
      this.dataGridDetails.instance.refresh();
      this.selectedRowsData = [];
      this.cellsDiff = [];
      notify({ closeOnClick: true, message: "Les partenaires ont été fusionnés" }, NotificationType.Success);
      this.sendSignal();
      } catch (error) {
        notify({ closeOnClick: true, message: `Une erreur est survenue sur le serveur : ${error}` }, NotificationType.Error);
      }finally{
        this.isMerging = false;
      }
    }
  }

  sendSignal(){
    this.setDataSourceSignal.emit(true);
  }
}
